"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _events = _interopRequireDefault(require("./events"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'MultiTab',
  data: function data() {
    return {
      fullPathList: [],
      pages: [],
      activeKey: '',
      newTabIndex: 0
    };
  },
  created: function created() {
    var _this = this;
    // bind event
    _events.default.$on('open', function (val) {
      if (!val) {
        throw new Error("multi-tab: open tab ".concat(val, " err"));
      }
      _this.activeKey = val;
    }).$on('close', function (val) {
      if (!val) {
        _this.closeThat(_this.activeKey);
        return;
      }
      _this.closeThat(val);
    }).$on('rename', function (_ref) {
      var key = _ref.key,
        name = _ref.name;
      console.log('rename', key, name);
      try {
        var item = _this.pages.find(function (item) {
          return item.path === key;
        });
        item.meta.customTitle = name;
        _this.$forceUpdate();
      } catch (e) {}
    });
    this.pages.push(this.$route);
    this.fullPathList.push(this.$route.fullPath);
    this.selectedLastPath();
  },
  methods: {
    onEdit: function onEdit(targetKey, action) {
      this[action](targetKey);
    },
    remove: function remove(targetKey) {
      this.pages = this.pages.filter(function (page) {
        return page.fullPath !== targetKey;
      });
      this.fullPathList = this.fullPathList.filter(function (path) {
        return path !== targetKey;
      });
      // 判断当前标签是否关闭，若关闭则跳转到最后一个还存在的标签页
      if (!this.fullPathList.includes(this.activeKey)) {
        this.selectedLastPath();
      }
    },
    selectedLastPath: function selectedLastPath() {
      this.activeKey = this.fullPathList[this.fullPathList.length - 1];
    },
    // content menu
    closeThat: function closeThat(e) {
      // 判断是否为最后一个标签页，如果是最后一个，则无法被关闭
      if (this.fullPathList.length > 1) {
        this.remove(e);
      } else {
        this.$message.info('这是最后一个标签了, 无法被关闭');
      }
    },
    closeLeft: function closeLeft(e) {
      var _this2 = this;
      var currentIndex = this.fullPathList.indexOf(e);
      if (currentIndex > 0) {
        this.fullPathList.forEach(function (item, index) {
          if (index < currentIndex) {
            _this2.remove(item);
          }
        });
      } else {
        this.$message.info('左侧没有标签');
      }
    },
    closeRight: function closeRight(e) {
      var _this3 = this;
      var currentIndex = this.fullPathList.indexOf(e);
      if (currentIndex < this.fullPathList.length - 1) {
        this.fullPathList.forEach(function (item, index) {
          if (index > currentIndex) {
            _this3.remove(item);
          }
        });
      } else {
        this.$message.info('右侧没有标签');
      }
    },
    closeAll: function closeAll(e) {
      var _this4 = this;
      var currentIndex = this.fullPathList.indexOf(e);
      this.fullPathList.forEach(function (item, index) {
        if (index !== currentIndex) {
          _this4.remove(item);
        }
      });
    },
    closeMenuClick: function closeMenuClick(key, route) {
      this[key](route);
    },
    renderTabPaneMenu: function renderTabPaneMenu(e) {
      var _this5 = this;
      var h = this.$createElement;
      return h("a-menu", {
        "on": _objectSpread({}, {
          click: function click(_ref2) {
            var key = _ref2.key,
              item = _ref2.item,
              domEvent = _ref2.domEvent;
            _this5.closeMenuClick(key, e);
          }
        })
      }, [h("a-menu-item", {
        "key": "closeThat"
      }, ["\u5173\u95ED\u5F53\u524D\u6807\u7B7E"]), h("a-menu-item", {
        "key": "closeRight"
      }, ["\u5173\u95ED\u53F3\u4FA7"]), h("a-menu-item", {
        "key": "closeLeft"
      }, ["\u5173\u95ED\u5DE6\u4FA7"]), h("a-menu-item", {
        "key": "closeAll"
      }, ["\u5173\u95ED\u5168\u90E8"])]);
    },
    // render
    renderTabPane: function renderTabPane(title, keyPath) {
      var h = this.$createElement;
      var menu = this.renderTabPaneMenu(keyPath);
      return h("a-dropdown", {
        "attrs": {
          "overlay": menu,
          "trigger": ['contextmenu']
        }
      }, [h("span", {
        "style": {
          userSelect: 'none'
        }
      }, [title])]);
    }
  },
  watch: {
    '$route': function $route(newVal) {
      this.activeKey = newVal.fullPath;
      if (this.fullPathList.indexOf(newVal.fullPath) < 0) {
        this.fullPathList.push(newVal.fullPath);
        this.pages.push(newVal);
      }
    },
    activeKey: function activeKey(newPathKey) {
      this.$router.push({
        path: newPathKey
      });
    }
  },
  render: function render() {
    var _this6 = this;
    var h = arguments[0];
    var onEdit = this.onEdit,
      pages = this.$data.pages;
    var panes = pages.map(function (page) {
      return h("a-tab-pane", {
        "style": {
          height: 0
        },
        "attrs": {
          "tab": _this6.renderTabPane(page.meta.customTitle || page.meta.title, page.fullPath),
          "closable": pages.length > 1
        },
        "key": page.fullPath
      });
    });
    return h("div", {
      "class": "ant-pro-multi-tab"
    }, [h("div", {
      "class": "ant-pro-multi-tab-wrapper"
    }, [h("a-tabs", {
      "attrs": {
        "hideAdd": true,
        "type": 'editable-card',
        "tabBarStyle": {
          background: '#FFF',
          margin: 0,
          paddingLeft: '16px',
          paddingTop: '1px'
        }
      },
      "on": _objectSpread({}, {
        edit: onEdit
      }),
      "model": {
        value: _this6.activeKey,
        callback: function callback($$v) {
          _this6.activeKey = $$v;
        }
      }
    }, [panes])])]);
  }
};